import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import download from "../../../assets/images/download.svg"
import date from "../../../assets/images/datePicker.svg"
import PropTypes from "prop-types";
export default function CreateWorkProgram(props) {
  useEffect(() => {
    CreateWorkProgramTable();
  }, []);

  const dataSet = [
    { "Domain": "HR Security", "Sub-Domain": "Roles and Responsibilities", "Control": "Individuals made aware of responsibilities", "Test Instruction": "To be measures against all individuals including 3P" },
    { "Domain": "Physical Security", "Sub-Domain": "Roles and Responsibilities", "Control": "Individuals made aware of responsibilities", "Test Instruction": "To be measures against all individuals including 3P" }
  ]

  const CreateWorkProgramTable = () => {
    // $(document).ready(function () {
    //   $('#tblCreateWorkProgram').DataTable({
    //     "scrollX": true, "initComplete": function (settings, json) {
    //       $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
    //     },
    //     data: dataSet,
    //     destroy: true,
    //     info: false,
    //     language: {
    //       paginate: {
    //         next: '&gt;', // or '→'
    //         previous: '&lt;' // or '←' 
    //       }
    //     },
    //     fields: [
    //       {
    //         label: "Domain:",
    //         name: "Domain",
    //       },
    //       {
    //         label: "Sub-Domain:",
    //         name: "Sub-Domain",
    //       },
    //       {
    //         label: "Control:",
    //         name: "Control",
    //       },
    //       {
    //         label: "Test Instruction:",
    //         name: "Test Instruction",
    //       },


    //     ],
    //     columns: [
    //       {
    //         "className": 'details-control',
    //         "orderable": false,
    //         "data": null,
    //         "defaultContent": ''
    //       },
    //       { data: "Domain" },
    //       {
    //         data: "Sub-Domain"
    //       },
    //       {
    //         data: "Control"
    //       },
    //       { data: "Test Instruction" },
    //     ]
    //   });
    // });
  }

  return (
    <div className="App">
      <div className="row text-right pt-3">
        <div className="col-md-12">
          <span className='appkiticon icon-arrow-left-outline pointer back-fill' onClick={props.handleBack}></span>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-sm-6">
          <div className="cv-input-field-container pt-0 pb-0">
            <label className="cv-input-label">
              Third Party Name
            </label>
            <input
              className="cv-input-field"
              type="text"
              name="name"
              value="James"
              readOnly="true"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="cv-input-field-container pt-0 pb-0">
            <label className="cv-input-label">
              Work Program Name
            </label>
            <input
              className="cv-input-field"
              type="text"
              name="name"
              value="Cybersecurity assessment of ABC"
              readOnly="true"
            />

          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <div className="cv-input-field-container pt-0 pb-0">
            <label className="cv-input-label">
              Previous Assessment Report
          </label>
            <input
              className="cv-input-field"
              type="text"
              name="name"
              value="2019"
              readOnly="true"
            />
            <img alt="edit" src={download} className="edit-input" style={{ transform: "rotate(90deg)" }} />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="cv-input-field-container pt-0 pb-0">
            <label className="cv-input-label">
              Instructions (if any)
          </label>
            <input
              className="cv-input-field"
              type="text"
              name="name"
              readOnly="true"
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <div className="cv-input-field-container pt-0 pb-0">
            <label className="cv-input-label">
              Validity
          </label>
            <input
              className="cv-input-field"
              type="text"
              value="01-Jan-2019 to 31-Jan-2019"
              readOnly="true"
              name="name"
            />
            <img alt="edit" src={date} className="edit-input" />
          </div>
        </div>
      </div>
      <div className="col-lg-12 mt-5 pl-1">
        <table id="tblCreateWorkProgram" className="table menu-tableAlignment-width">
          <thead className="table-header-etp">
            <tr>
              <th className="w-50p"></th>
              <th>Domain</th>
              <th>Sub-Domain</th>
              <th>Control</th>
              <th>Test Instruction</th>
            </tr>
          </thead>
        </table>
      </div>

      <div className="options-container">
        <button
          className="cancel-button m-l-2"
          type="reset"
          onClick={props.handleBack}
        >
          Close
        </button>
      </div>
    </div>
  )
}

CreateWorkProgram.propTypes = {
  handleBack: PropTypes.any
}